import ImgixClient from 'imgix-core-js';

const imgixClient = new ImgixClient({
  domain: 'addnorth.imgix.net',
  secureURLToken: 'd4bSYv3Pv7BcHxza',
  useHttps: true,
});

export default imgixClient;
